import { render, staticRenderFns } from "./classlive.vue?vue&type=template&id=edce0d3c&scoped=true"
import script from "./classlive.vue?vue&type=script&lang=js"
export * from "./classlive.vue?vue&type=script&lang=js"
import style0 from "./classlive.vue?vue&type=style&index=0&id=edce0d3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edce0d3c",
  null
  
)

export default component.exports